export default __webpack_public_path__ + "static/media/dashboard-ic.c976cdb4.svg";